import {Component} from '@angular/core';

@Component({
  selector: 'tag-node',
  templateUrl: './tag-node.component.html'
})
export class TagNodeComponent {
    node
}
